import removeTimeZoneFromDateString from '@justpark/helpers/src/removeTimeZoneFromDateString/removeTimeZoneFromDateString';
import redirectWithNewParams from '../helpers/redirectWithNewParams';

export const handleSearchRedirects = (request) => {
  const { url } = request;
  const { pathname, searchParams } = new URL(url);
  const queryParams = Object.fromEntries(searchParams);

  const updatedParams = removeTimeZoneFromDateString(queryParams);

  if (updatedParams) {
    return redirectWithNewParams(pathname, updatedParams);
  }

  return null;
};

const searchResultsLoader = async ({ request }) =>
  handleSearchRedirects(request);

export default searchResultsLoader;
